import Vue from "vue";

import { UserService } from "@/storage";

class Permission {
  static parse(action) {
    throw new Error("module getter not defined.");
  }

  static hasPermission(action) {
    const permission = this.parse(action);
    const user = UserService.getUser();

    return user.is_superuser || user.permissions.includes(permission);
  }
}

class Businesses extends Permission {
  static parse(action) {
    return `businesses:${action}`;
  }

  static get read() {
    return this.hasPermission("read");
  }

  static get create() {
    return this.hasPermission("create");
  }

  static get update() {
    return this.hasPermission("update");
  }

  static get delete() {
    return this.hasPermission("delete");
  }
}

class Groups extends Permission {
  static parse(action) {
    return `groups:${action}`;
  }

  static get read() {
    return this.hasPermission("read");
  }

  static get create() {
    return this.hasPermission("create");
  }

  static get update() {
    return this.hasPermission("update");
  }

  static get delete() {
    return this.hasPermission("delete");
  }
}

class Users extends Permission {
  static parse(action) {
    return `users:${action}`;
  }

  static get read() {
    return this.hasPermission("read");
  }

  static get create() {
    return this.hasPermission("create");
  }

  static get update() {
    return this.hasPermission("update");
  }

  static get delete() {
    return this.hasPermission("delete");
  }

  static get activate() {
    return this.hasPermission("activate");
  }

  static get deactivate() {
    return this.hasPermission("deactivate");
  }
}

const Permissions = {
  install(Vue) {
    Vue.prototype.$permissions = class {
      static get businesses() {
        return Businesses;
      }
      static get groups() {
        return Groups;
      }
      static get users() {
        return Users;
      }
    };
  },
};

Vue.use(Permissions);
